import { Components, Theme } from "@mui/material/styles";

export const MuiToggleButton: Components<Theme>["MuiToggleButton"] = {
  styleOverrides: {
    root: {
      textTransform: "none",
      marginRight: "4px",
      padding: "10px 16px",
      borderRadius: "4px",
    },
  },
  variants: [
    {
      props: { color: "primary" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-primary)",
        border: "none",
        "&:hover": { backgroundColor: "var(--mui-palette-fsw-blue-5)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-fsw-blue-5)",
          color: "var(--mui-palette-text-primary)",
          border: "1px solid var(--mui-palette-fsw-blue-10)",
          borderLeft: "1px solid var(--mui-palette-fsw-blue-10)",
          borderRadius: "4px",
          fontWeight: "700",
          "&:hover": {
            backgroundColor: "var(--mui-palette-fsw-blue-5)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "secondary" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-secondary-main)",
          color: "var(--mui-palette-secondary-contrastText)",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "error" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-error-main)",
          color: "var(--mui-palette-error-contrastText)",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "warning" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-warning-main)",
          color: "var(--mui-palette-warning-contrastText)",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "info" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-info-main)",
          color: "var(--mui-palette-info-contrastText)",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "success" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "var(--mui-palette-success-main)",
          color: "var(--mui-palette-success-contrastText)",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
    {
      props: { color: "standard" },
      style: {
        backgroundColor: "transparent",
        color: "var(--mui-palette-text-secondary)",
        border: "1px solid var(--mui-palette-divider)",
        "&:hover": { backgroundColor: "var(--mui-palette-action-hover)" },
        "&.Mui-disabled": {
          color: "var(--mui-palette-action-disabled)",
        },
        "&.Mui-focusVisible": {
          "& .MuiTouchRipple-ripple": { opacity: 1 },
          "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
        },
        "&.Mui-selected": {
          backgroundColor: "rgba(0, 0, 0, 0.87)",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "var(--mui-palette-action-hover)",
            color: "var(--mui-palette-text-primary)",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--mui-palette-action-disabledBackground)",
            color: "var(--mui-palette-action-primary)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
            color: "var(--mui-palette-action-primary)",
            "& .MuiTouchRipple-ripple": { opacity: 1 },
            "& .MuiTouchRipple-child": { backgroundColor: "var(--mui-palette-action-focus)" },
          },
        },
      },
    },
  ],
};
